<template>
  <text-field-autocomplete 
  v-model="model"
  :item-text="itemText"
  :item-value="itemValue"
  :label="$t('textFields.selectRole')"
  :items="getItems"
  :required="required"
  :disabled="disabled"/>
</template>

<script>
import TextFieldAutocomplete from '@/components/text-fields/TextFieldAutocomplete'
import { ROLES } from '@/utils/rolesUtil'
export default {
  components: {
    TextFieldAutocomplete
  },
  props: {
    value: [Object, String],
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      defualt: false
    },
    disabled: {
      type: Boolean,
      defualt: false
    },
    rolesOnly: {
      type: Array,
      default: null
    }
  },
  model: {
    prop: "value",
    event: "valueChanged"
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit("valueChanged", v)
      }
    },
    getItems() {
      if (!this.rolesOnly) return this.roles

      return this.roles.filter(o => this.rolesOnly.includes(o.key))
    }
  },
  data() {
    return {
      roles: ROLES
    }
  }
}
</script>

<style>

</style>